import { render, staticRenderFns } from "./HistoricalOrders.vue?vue&type=template&id=5fc8a0ab&scoped=true&"
import script from "./HistoricalOrders.vue?vue&type=script&lang=js&"
export * from "./HistoricalOrders.vue?vue&type=script&lang=js&"
import style0 from "./HistoricalOrders.vue?vue&type=style&index=0&id=5fc8a0ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc8a0ab",
  null
  
)

export default component.exports